// extracted by mini-css-extract-plugin
module.exports = {"navHeader":"NavHeader_navHeader__T3uCE","navheaderContent":"NavHeader_navheaderContent__26mGt","text":"NavHeader_text__9dOxD"};